import { yup } from '@guiker/yup-util'

import { ScopeType } from '../../entity'

export const byScope = yup.object({
  scopeType: yup.string().oneOf(Object.values(ScopeType)).required(),
  scopeId: yup.string().required(),
})
